export default __webpack_public_path__ + "static/media/Kuthcheman Greatsword.67720e5f.jpg";